import Audience from 'components/Form/Audience'
import AudioArrayField from 'components/Form/AudioArrayField'
import AudioIdField from 'components/Form/AudioIdField'
import Autocomplete from 'components/Form/Autocomplete'
import AutocompleteMultiple from 'components/Form/AutocompleteMultiple'
import CategoryArrayField from 'components/Form/CategoryArrayField'
import DocumentArrayField from 'components/Form/DocumentArrayField'
import EntryArrayField from 'components/Form/EntryArrayField'
import FieldButton from 'components/Form/FieldButton'
import FieldLabel from 'components/Form/FieldLabel'
import FileUploadField from 'components/Form/FileUploadField'
import GalleryField from 'components/Form/GalleryField'
import Header from 'components/Form/Header'
import HelpText from 'components/Form/HelpText'
import ImageArrayField from 'components/Form/ImageArrayField'
import ImageIdField from 'components/Form/ImageIdField'
import IncludeInGames from 'components/Form/IncludeInGames'
import IncludeInKids from 'components/Form/IncludeInKids'
import NextPrevious from 'components/Form/NextPrevious'
import RadioButtons from 'components/Form/RadioButtons'
import Select from 'components/Form/Select'
import SelectOneMedia from 'components/Form/SelectOneMedia'
import Stepper from 'components/Form/Stepper'
import StepWrapper from 'components/Form/StepWrapper'
import SubmitButtons from 'components/Form/SubmitButtons'
import TextField from 'components/Form/TextField'
import TextAreaField from 'components/Form/TextAreaField'
import TextArrayField from 'components/Form/TextArrayField'
import TextTranslationArrayField from 'components/Form/TextTranslationArrayField'
import ValidationError from 'components/Form/ValidationError'
import VideoArrayField from 'components/Form/VideoArrayField'
import VideoIdField from 'components/Form/VideoIdField'
import Visibility from 'components/Form/Visibility'
import WysiwygField from 'components/Form/WysiwygField'
import XButton from 'components/Form/XButton'

export default {
  Audience,
  AudioArrayField,
  AudioIdField,
  Autocomplete,
  AutocompleteMultiple,
  CategoryArrayField,
  DocumentArrayField,
  EntryArrayField,
  FieldButton,
  FieldLabel,
  FileUploadField,
  GalleryField,
  Header,
  HelpText,
  ImageArrayField,
  ImageIdField,
  IncludeInGames,
  IncludeInKids,
  NextPrevious,
  RadioButtons,
  Select,
  SelectOneMedia,
  Stepper,
  StepWrapper,
  SubmitButtons,
  TextField,
  TextAreaField,
  TextArrayField,
  TextTranslationArrayField,
  ValidationError,
  VideoArrayField,
  VideoIdField,
  Visibility,
  WysiwygField,
  XButton,
}
